/**
 * Boxes as printed on ICS 220UAS-CG (Jan 2026), UAS Air Operations Summary.
 *
 * Box 4 covers the whole flight-authorisation group: the two Yes/No questions
 * printed above it, the TFR number and the waiver details.
 */
export const ICS220UAS_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  specialProcess: '4. Special Process in Place to Support UAS Missions:',
  personnel: '5. Personnel and Communications:',
  remarks: '6. Remarks:',
  flightDetails: '7. UAS Flight Details:',
  preparedBy: '8. Prepared By: (Air Operations Branch Director)',
} as const;

/** The two Yes/No questions box 4 asks. */
export const ICS220UAS_AUTHORIZATION_QUESTIONS = [
  {
    key: 'tfr_in_place',
    label: 'Temporary Flight Restriction (TFR) in Place?',
  },
  {
    key: 'waivers_in_place',
    label: 'Waivers/Authorization in Place?',
  },
] as const;

/** The two blanks box 4 prints beside its questions. */
export const ICS220UAS_AUTHORIZATION_FIELDS = [
  { key: 'tfr_number', label: 'Temporary Flight Restriction Number' },
  { key: 'waiver_details', label: 'Waiver/Authorization Details' },
] as const;

/** Box 5 rows, each with a name, an air/air frequency and a phone blank. */
export const ICS220UAS_PERSONNEL_ROWS = [
  { key: 'airOperationsBranchDirector', label: 'Air Operations Branch Director' },
  { key: 'uasDivisionGroupSupervisor', label: 'UAS Division/Group Supervisor' },
  { key: 'uasAssistantSafetyOfficer', label: 'UAS Assistant Safety Officer' },
  { key: 'uasOperatorRemotePilot', label: 'UAS Operator/Remote Pilot' },
  { key: 'uasVisualObserver', label: 'UAS Visual Observer' },
  { key: 'uasTechnician', label: 'UAS Technician' },
  { key: 'uasDataSpecialist', label: 'UAS Data Specialist / GIS Processor' },
] as const;

/** Columns of box 7. */
export const ICS220UAS_MISSION_COLUMNS = [
  { key: 'start_date', label: 'Commence Date' },
  { key: 'start_time', label: 'Commence Time' },
  { key: 'uas_id', label: 'UAS Category / UAS ID' },
  { key: 'uas_type', label: 'UAS Type' },
  { key: 'mission_type', label: 'Mission Type' },
  { key: 'location', label: 'Mission Location' },
  { key: 'pilot', label: 'UAS Pilot' },
  { key: 'complete_time', label: 'Completion Time' },
  { key: 'total_hours', label: 'Total Hours' },
] as const;
